angular.module('eStories.genre', [
    /*eStories Browse*/
    'eStories.catalog.model',
    'eStories.compnt.grid',
    'eStories.paging.model',
    'eStories.sortFilter'
])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('eStories.navbars.browseGenre', {
                url: 'genres/:genreName?pageNumber&subGenreId&sortField&languageId&duration&abridged&onlyForCredit&onlyForFree&onlyOnSale',
                views: {
                    'mainView@': {
                        controller: 'BrowseGenreCtrl as browseGenreCtrl',
                        templateUrl: 'store/genre/browseGenre.tmpl.html'
                    }
                }
            });
    }])
    .controller('BrowseGenreCtrl', [
        'CatalogModel',
        'PagingModel',
        'SortFilterFactory',
        '$rootScope',
        '$stateParams',
        '$location',
        '$scope',
        '$state',
        '$window',
        'SeoModel',
        'GA',
        function (CatalogModel,
                  PagingModel,
                  SortFilterFactory,
                  $rootScope,
                  $stateParams,
                  $location,
                  $scope,
                  $state,
                  $window,
                  SeoModel,
                  GA) {

            var browseGenreCtrl = this;

            GA.trackPageView($location.url());

            browseGenreCtrl.genreName = $stateParams.genreName.replace(/_/g, " ");

            browseGenreCtrl.currentState = $state.current.name;

            browseGenreCtrl.bioCharacterLimit = 730;

            SeoModel.applyMetaTags(browseGenreCtrl.currentState, browseGenreCtrl.genreName);

            $rootScope.$on("windowResized", function () {
                if ($window.innerWidth < 650) {
                    browseGenreCtrl.listView = false
                } else {
                    browseGenreCtrl.listView = SortFilterFactory.listViewMode[browseGenreCtrl.currentState].mode;
                }
            });

            browseGenreCtrl.assignGenreIdToGlobalFilter = function (genreId) {
                globalFilterObj.genreId = genreId ? parseInt(genreId) : globalFilterObj.genreId;
            };

            PagingModel.updatePageNumber(browseGenreCtrl.currentState, parseInt($stateParams.pageNumber) || 1);

            if (PagingModel.pagingData[browseGenreCtrl.currentState].totalCount === null) {
                SortFilterFactory.resetFilterObj();
            }

            //Extracts all the get Params , uses the previous saved Params and updates them
            var globalFilterObj = SortFilterFactory.filterObj;
            globalFilterObj.languageId = $stateParams.languageId ? $stateParams.languageId : globalFilterObj.languageId;
            globalFilterObj.onlyForCredit = $stateParams.onlyForCredit || globalFilterObj.onlyForCredit;
            globalFilterObj.onlyForFree = $stateParams.onlyForFree || globalFilterObj.onlyForFree;
            globalFilterObj.onlyOnSale = $stateParams.onlyOnSale || globalFilterObj.onlyOnSale;

            /*Initial Call*/
            browseGenreCtrl.findParentGenreId = async () => {
                const response = await CatalogModel.getFilterGenreList({});
                if (response.responseText !== "SUCCESS") {
                    return;
                }

                browseGenreCtrl.allFilterGenres = response.genreList;
                for (i = 0; i < response.genreList.length; i++) {
                    if (response.genreList[i].name.toUpperCase() === browseGenreCtrl.genreName.toUpperCase()) {
                        var topLevelGenreId = response.genreList[i].id;
                        browseGenreCtrl.assignGenreIdToGlobalFilter(topLevelGenreId);
                        if ($stateParams.subGenreId) {
                            globalFilterObj.subGenreId = $stateParams.subGenreId ? parseInt($stateParams.subGenreId) : globalFilterObj.subGenreId;
                        }
                        $scope.$broadcast('newGenreId', topLevelGenreId, $stateParams.subGenreId);
                        browseGenreCtrl.getPage(PagingModel.pagingData[browseGenreCtrl.currentState].pageNumber);
                    }
                }
            };

            globalFilterObj.subGenreId = $stateParams.subGenreId ? parseInt($stateParams.subGenreId) : globalFilterObj.subGenreId;
            globalFilterObj.sortField = $stateParams.sortField || 'most_popular';
            globalFilterObj.duration = $stateParams.duration || globalFilterObj.duration;
            globalFilterObj.abridged = $stateParams.abridged || globalFilterObj.abridged;
            browseGenreCtrl.descendingOrder = true;

            $rootScope.$on('changeGridView', function (event, toggle) {
                browseGenreCtrl.listView = toggle;
                SortFilterFactory.listViewMode[browseGenreCtrl.currentState].mode = toggle;
                safeApply($scope);
            });

            /*Request Obj*/
            browseGenreCtrl.sortField = globalFilterObj.sortField ? globalFilterObj.sortField.toUpperCase() : null;

            browseGenreCtrl.browseFilter = {
                abridged: globalFilterObj.abridged ? JSON.parse(globalFilterObj.abridged) : null,
                onlyForFree: globalFilterObj.onlyForFree ? JSON.parse(globalFilterObj.onlyForFree) : null,
                onlyForCredit: globalFilterObj.onlyForCredit ? JSON.parse(globalFilterObj.onlyForCredit) : null,
                onlyOnSale: globalFilterObj.onlyOnSale ? JSON.parse(globalFilterObj.onlyOnSale) : null
            };

            if (globalFilterObj.languageId) {
                browseGenreCtrl.browseFilter.languageIdList = [];
                var languageArray = globalFilterObj.languageId.split(',');
                for (var i = 0; i < languageArray.length; i++) {
                    browseGenreCtrl.browseFilter.languageIdList.push(parseInt(languageArray[i]));
                }
            }

            if (globalFilterObj.duration) {
                browseGenreCtrl.browseFilter.durationFilterList = [];
                var durationArray = globalFilterObj.duration.split(',');
                for (i = 0; i < durationArray.length; i++) {

                    var c = durationArray[i];
                    browseGenreCtrl.browseFilter.durationFilterList.push({
                        minHours: c.match(/.+?(?=-)/) != null ? parseInt(c.match(/.+?(?=-)/)) : null,
                        maxHours: c.match(/[^-]+$/) != null ? parseInt(c.match(/[^-]+$/)) : null
                    });
                }
            }

            //Check sortField alphabetical descending status
            if (globalFilterObj.sortField) {
                if (globalFilterObj.sortField === 'alphabetically') {
                    browseGenreCtrl.descendingOrder = false;
                } else if (globalFilterObj.sortField === 'alphabetically_descending') {
                    browseGenreCtrl.sortField = 'ALPHABETICALLY';
                }
            }

            /*Setup Cover Images*/

            formatGenreNameForBackgroundUrl = function (string) {
                var formattedString = string.replace(/[^\w]/g, '_').toUpperCase();
                return 'GENRE_HEADER_' + formattedString;
            };

            getCoverStyleBackground = function (url) {
                return {
                    'background-image': 'url(' + url + ')',
                    'background-repeat': 'no-repeat',
                    'background-position': 'center',
                    'background-size': 'cover'
                };
            };

            browseGenreCtrl.getHeaderBackgroundImage = function () {
                if (browseGenreCtrl.genreHeaderBackgroundUrl) {
                    return getCoverStyleBackground(browseGenreCtrl.genreHeaderBackgroundUrl);
                }
            };

            browseGenreCtrl.getMobileHeaderBackgroundImage = function () {
                if (browseGenreCtrl.genreMobileHeaderBackgroundUrl) {
                    return getCoverStyleBackground(browseGenreCtrl.genreMobileHeaderBackgroundUrl);
                }
            };

            // Grid View or List View when loading
            if (browseGenreCtrl.currentState !== 'eStories.navbars.browseGenre') {
                browseGenreCtrl.listView = $window.innerWidth < 650 ? false : SortFilterFactory.listViewMode[browseGenreCtrl.currentState].mode;
            } else {
                browseGenreCtrl.listView = $window.innerWidth < 650 ? false : SortFilterFactory.listViewMode[browseGenreCtrl.currentState].mode;
                CatalogModel.getSectionByName(formatGenreNameForBackgroundUrl(browseGenreCtrl.genreName)).then((response) => {
                    browseGenreCtrl.genreHeaderBackgroundUrl = response.section.backgroundUrl;
                    browseGenreCtrl.genreMobileHeaderBackgroundUrl = response.section.mobileBackgroundUrl;
                    browseGenreCtrl.genreHeaderTitle = response.section.title['en'];
                    browseGenreCtrl.genreBackgroundContainsEmbeddedTitle =
                        response.section.backgroundContainsEmbeddedTitle;
                    browseGenreCtrl.genreMobileBackgroundContainsEmbeddedTitle =
                        response.section.mobileBackgroundContainsEmbeddedTitle;
                });
            }

            //Parent function
            browseGenreCtrl.getPage = async function (pageNumber, callbackFunc, isMobile) {
                browseGenreCtrl.callInProgress = true;
                browseGenreCtrl.askForTotalCount = PagingModel.pagingData[browseGenreCtrl.currentState].totalCount == null;

                var pagination = PagingModel.preparePagination(
                    pageNumber,
                    42,
                    browseGenreCtrl.descendingOrder,
                    true,
                    browseGenreCtrl.sortField
                );

                browseGenreCtrl.browseFilter.genreIdList = $stateParams.subGenreId ?
                    [SortFilterFactory.filterObj.subGenreId] : [SortFilterFactory.filterObj.genreId];

                const response = await CatalogModel.getAllAudiobooks(browseGenreCtrl.browseFilter, pagination, null);
                if (response.responseStatus !== 'SUCCESS') {
                    return;
                }

                if (isMobile && pageNumber > 1) {
                    browseGenreCtrl.audiobookBrowseList = browseGenreCtrl.audiobookBrowseList.concat(response.audiobookList)
                } else {
                    browseGenreCtrl.audiobookBrowseList = response.audiobookList;
                }

                PagingModel.updateResultsData(browseGenreCtrl.currentState, browseGenreCtrl.askForTotalCount ? response.totalCount : null);

                browseGenreCtrl.callInProgress = false;
                var totalCount = response.totalCount;
                $rootScope.$broadcast('setTotalCount', totalCount);
                if (callbackFunc) {
                    callbackFunc(response);
                }
            };

            browseGenreCtrl.findParentGenreId();

            browseGenreCtrl.replaceGenreName = function (filterObj) {
                if (filterObj.filterType === 'genreId') {
                    delete globalFilterObj.subGenreId;
                    delete globalFilterObj.abridged;
                    delete globalFilterObj.onlyForFree;
                    delete globalFilterObj.onlyForCredit;
                    delete globalFilterObj.onlyOnSale;

                    $stateParams.subGenreId = null;
                    $stateParams.abridged = null;
                    $stateParams.onlyForFree = null;
                    $stateParams.onlyForCredit = null;
                    $stateParams.onlyOnSale = null;

                    for (i = 0; i < browseGenreCtrl.allFilterGenres.length; i++) {
                        if (filterObj) {
                            if (filterObj.obj === browseGenreCtrl.allFilterGenres[i].id) {
                                browseGenreCtrl.genreName = browseGenreCtrl.allFilterGenres[i].name.replace(/ /g, "_");
                                SortFilterFactory.resetFilterObj(function (response) {
                                    $state.go('eStories.navbars.browseGenre', {genreName: browseGenreCtrl.genreName});
                                });

                            }
                        }
                    }
                }
            };

            function constructGetParamsObj(pageNumber, filterObj) {
                //Save pagingData currentPage globally
                PagingModel.pagingData.currentPage = pageNumber;
                for (var param in globalFilterObj) {
                    if (!globalFilterObj[param]) {
                        delete globalFilterObj[param];
                    }
                }

                globalFilterObj.pageNumber = pageNumber;
                if (filterObj && filterObj['obj']) {
                    if (filterObj.filterType === 'genreId') {
                        delete globalFilterObj.subGenreId;
                        delete globalFilterObj.genreId;
                    }
                    if (filterObj.filterType === 'subGenreId') {
                        delete globalFilterObj.subGenreId;
                    }
                    globalFilterObj[filterObj.filterType] = filterObj.obj;
                }
                return globalFilterObj
            }

            /*Listener to paging component*/
            $scope.$on('getPage', function (event, pageNumber) {
                if (browseGenreCtrl.callInProgress) return;
                var filterObj = constructGetParamsObj(pageNumber);
                $location.search(filterObj);
            });

            $scope.$on('loadMore', function (event, pageNumber) {
                PagingModel.pagingData[browseGenreCtrl.currentState].pageNumber = pageNumber;
                browseGenreCtrl.getPage(pageNumber, null, true);
            });

            //Listener to sortFilter Component
            $scope.$on('updateFilter', function (event, filterObj) {
                PagingModel.pagingData[browseGenreCtrl.currentState].totalCount = null;
                PagingModel.pagingData[browseGenreCtrl.currentState].totalPageCount = null;
                if (filterObj.filterType === 'genreId') {
                    //clears subGenre, purchase filters
                    return browseGenreCtrl.replaceGenreName(filterObj);
                }

                filterObj = constructGetParamsObj(null, filterObj);
                $location.search(filterObj);
            });

            browseGenreCtrl.getHeaderTitle = function (title) {
                if (!title) return;
                return title.replace('&', 'and');
            };

        }]);
